<template>
    <div class="modal" :class="{'is-active': active}">
        <div class="modal-background"></div>
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">{{ $t('recommandation_title') }}</p>
            </header>
            <section class="modal-card-body">
                <div class="notification is-primary">{{ $t('intro_text') }}</div>

                <div v-for="(recommendation, key) in newRecommendations" :key="key">
                    <div class="columns">
                        <div class="column is-5">
                            <div class="field">
                                <label class="label" v-text="$t('contact_name_label')"></label>
                                <p class="control has-icon has-icons-right">
                                    <input
                                        v-validate="'required'"
                                        :class="{'input': true, 'is-danger': errors.has(`newRecommendations.${key}.name`) }"
                                        v-model="recommendation.name"
                                        :name="`newRecommendations.${key}.name`"
                                        type="text">
                                    <span v-show="errors.has('newRecommendations.' + key + '.name')" class="icon is-right is-danger"><i class="mdi mdi-alert-circle mdi-24px"></i></span>
                                </p>
                            </div>
                        </div>
                        <div class="column is-5">
                            <div class="field">
                                <label class="label" v-text="$t('contact_email_label')"></label>
                                <p class="control has-icon has-icons-right">
                                    <input
                                        v-validate="'required|email'"
                                        :class="{'input': true, 'is-danger': errors.has(`newRecommendations.${key}.email`) }"
                                        v-model="recommendation.email"
                                        :name="`newRecommendations.${key}.email`"
                                        type="email">
                                    <span v-show="errors.has('newRecommendations.' + key + '.email')" class="icon is-right is-danger"><i class="mdi mdi-alert-circle mdi-24px"></i></span>
                                </p>
                            </div>
                        </div>
                        <div class="column is-2">
                            <div class="field" v-if="key >= 2">
                                <label class="label">&nbsp;</label>
                                <p class="control">
                                    <button class="button is-danger is-outlined" :disabled="isModalLoading" @click.prevent="removeRecommendation(key)">{{ $t('remove_doctor') }}</button>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <button class="button is-info is-outlined mt-3" :disabled="isModalLoading" @click.prevent="addRecommendation()">{{ $t('add_another_doctor') }}</button>
            </section>
            <footer class="modal-card-foot">
                <button class="button" type="button" :disabled="isModalLoading" @click.prevent="close()">{{ $t('close_button_label') }}</button>
                <button class="button is-primary":class="{'is-loading': isModalLoading}" @click.prevent="confirm()">{{ $t('submit_button_label') }}</button>
            </footer>
        </div>
    </div>
</template>

<script>
import helpers from '@/mixins/helpers'
import { store } from '@/store'

import recommendationRepository from '@/data/RecommendationRepository'

export default {
    name: 'recommendations-modal',

    props: ['active'],

    mixins: [helpers],

    data () {
        return {
            newRecommendations: [],
            isModalLoading: false
        }
    },

    mounted() {
        this.addRecommendation()
        this.addRecommendation()
    },

    methods: {
        close () {
            if (! this.isModalLoading) {
                this.$emit('close')
                document.documentElement.classList.toggle('is-clipped', false)
            }
        },

        addRecommendation () {
            this.newRecommendations.push({
                "email": "",
                "name": ""
            })
        },

        removeRecommendation (key) {
            this.newRecommendations.splice(key, 1)
        },

        confirm () {
            this.isModalLoading = true

            this.$validator.validateAll().then((result) => {
                if (! result) {
                    this.isModalLoading = false

                    return false
                }

                recommendationRepository.createMany(this.doctor, this.newRecommendations, () => {
                    // Success
                    this.isModalLoading = false

                    this.close()

                    this.alertSuccess(this.$t('thanks_message'))
                }, (error) => {
                    // Error
                    this.isModalLoading = false

                    this.alertError(error.message)
                })
            })
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Doctor/RecommendationsModal.vue